import OrderPackingLists from "@iewcasia/Components/OrderPackingLists";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: any) => ({
    order: state.pages.orderStatus?.order,
});

type Props = ReturnType<typeof mapStateToProps>;

const OrderStatusPackingLists: FC<Props> = ({ order }) => {
    return order ? (
      <OrderPackingLists {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderStatusPackingLists),
    definition: {
        allowedContexts: ["OrderStatusPage"],
        displayName: "Order Packing Lists",
        group: "Order Status",
    },
};

export default widgetModule;
